<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ "input-category" | translate }}</mat-label
      ><input
        type="text"
        matInput
        formControlName="name"
        [matAutocomplete]="auto"
        [required]="required"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let partCategory of partCategories"
          (onSelectionChange)="handlePartCategoryChange($event, partCategory)"
          [value]="partCategory.categoryName"
          class="autocomplete"
        >
          {{ partCategory.categoryName }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="!this.searchForm.valid">{{
        "required-category" | translate
      }}</mat-error>
    </mat-form-field>
  </div>
</form>
